import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { AcctRatingRule, AcctRatingRuleCode } from "./se.org.status.service";

export type AcctRatingWarnMessageChange = {
    acctRatingId: number;
    ruleCode: AcctRatingRuleCode;
    message: string;
};

@TypeManagerDecorator("s25-ng-se-org-status-warn-messages")
@Component({
    selector: "s25-ng-se-org-status-warn-messages",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, FormsModule],
    template: `
        <div class="se-org-status-warn-messages">
            <p class="ngBold se-org-status-warn-messages__heading">Warn messages</p>
            @for (rule of warnRules(); track rule.ruleCode) {
                <div class="se-org-status-warn-messages__field">
                    <label class="c-label" [attr.for]="fieldId(rule.ruleCode)">
                        {{ ruleLabel(rule.ruleCode) }}
                    </label>
                    <textarea
                        class="cn-form__control"
                        rows="2"
                        [id]="fieldId(rule.ruleCode)"
                        [ngModel]="rule.message ?? ''"
                        (ngModelChange)="onMessageChange(rule.ruleCode, $event)"
                        placeholder="Message to display when in Warn mode"
                    ></textarea>
                </div>
            }
        </div>
    `,
    styles: `
        .se-org-status-warn-messages {
            display: flex;
            flex-direction: column;
            gap: 0.75rem;
            padding: 0.5rem 0;
        }

        .se-org-status-warn-messages__heading {
            margin: 0;
        }

        .se-org-status-warn-messages__field {
            display: flex;
            flex-direction: column;
            gap: 0.25rem;
        }
    `,
})
export class SeOrgStatusWarnMessagesComponent {
    readonly acctRatingId = input.required<number>();
    readonly warnRules = input.required<AcctRatingRule[]>();
    readonly ruleLabelByCode = input.required<Partial<Record<AcctRatingRuleCode, string>>>();

    readonly messageChange = output<AcctRatingWarnMessageChange>();

    fieldId(ruleCode: AcctRatingRuleCode): string {
        return `warn-${this.acctRatingId()}-${ruleCode}`;
    }

    ruleLabel(ruleCode: AcctRatingRuleCode): string {
        return this.ruleLabelByCode()[ruleCode] ?? ruleCode;
    }

    onMessageChange(ruleCode: AcctRatingRuleCode, message: string): void {
        this.messageChange.emit({
            acctRatingId: this.acctRatingId(),
            ruleCode,
            message,
        });
    }
}
